'use client';
import { cn } from '@bells/core/lib/utils';
import { Button } from '../../../components/button';
import { layoutSearchTitle } from '@bells/i18n';
import { useAppSettings } from '@bells/core';

export const HeaderSearchButton = () => {
  const { setUseSearch } = useAppSettings();
  return (
    <Button
      variant='outline'
      onClick={() => setUseSearch(true)}
      className={cn(
        'relative h-8 w-full justify-start rounded-[0.5rem] text-sm font-normal text-muted-foreground shadow-none sm:pr-12 md:w-40 lg:w-56 xl:w-64'
      )}
    >
      <span className='inline-flex'>{layoutSearchTitle()}</span>
      <kbd className='pointer-events-none absolute right-[0.3rem] top-[0.3rem] hidden h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium opacity-100 sm:flex'>
        <span className='text-xs'>⌘</span>K
      </kbd>
    </Button>
  );
};
